import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { colors, fonts, useMediaQuery } from "../../../Styles";
import { DataObj, getLabelFromKey} from "../../../Definitions";
import { CheckBox, CheckStyles } from "../..";
import { useReportContext } from "../_Reports/reportModalContext";



export default function ReportModalLvl3() {
  const { t } = useTranslation()
  const { state: { report }, dispatch } = useReportContext();
  
  const mobileXs = useMediaQuery(`(max-width: 690px)`);

  const checkboxes = useMemo(() => {
    const dataParameters: DataObj[] = [
      // "locationId", 
      "animal_group_id", 
      // "conditionId", 
      // "attentionId", 
      "milestone_id"
    ];

    return dataParameters.map((param, index) => {
      const label = getLabelFromKey(param);
      
      return (
        <CheckBox
          key={index}
          text={t(`params.${label}`, {defaultValue: `${label}`})}
          checkStyle={CheckStyles.blue}
          isChecked={report?.dataParameter?.includes(param)}
          onChange={() => {
            const isChecked = report?.dataParameter?.includes(param);
            const updatedParams = isChecked
              ? report && report.dataParameter?.filter(id => id !== (param))
              : [...(report?.dataParameter || []), param];
            dispatch({ report: {dataParameter: updatedParams} });
          }}
        />
      );
    });
  }, [dispatch, report, t]);
  
  return(
    <div style={{ width: "fit-content", display: "flex", flexWrap: "wrap", columnGap: "60px", rowGap: "10px", margin: "0 auto", flexDirection: mobileXs ? "column" : "row" }}>  
      {/* {checkboxes} */}
      <p style={{...fonts.fontSize4, ...fonts.paragraph, color: colors.greyLightTertiary, fontStyle: "italic", marginTop: "20px"}}>Future feature...</p>
    </div>
  )
}